import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Spinner } from "./ui";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  if (user === undefined) return <Spinner />;
  if (user === null) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    const home = user.role === "ADMIN" ? "/admin" : user.role === "WORKER" ? "/worker" : "/customer";
    return <Navigate to={home} replace />;
  }
  return children;
}
